import { useEffect } from 'react';

const useScrollEffect = (handler) =>
  useEffect(() => {
    if (!process.browser) {
      return () => {};
    }

    window.addEventListener('scroll', handler);
    handler();
    return () => window.removeEventListener('scroll', handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

export default useScrollEffect;
